import React from 'react'
import { get } from 'lodash'
import { useQuery } from '@apollo/client'
import Error from 'components/error'
import { useAuth } from 'lib/auth'
import { Grid, Divider } from '@material-ui/core'
import { LessonReviewQuery, GetStudentsQuery } from './query'
import SelectStudentSkeleton from './select-student-skeleton'
import SelectStudentLayout from './SelectStudentLayout'
import SelectStudentLayoutRefresh from './SelectStudentLayoutRefresh'
import CreateAccountForBookingLayout from './CreateAccountForBookingLayout'
import CreateAccountForBookingRefreshLayout from '../SelectStudentRefresh/CreateAccountForBookingLayout.js'
import LessonTypeCard from '../LessonTypeCard'
import CoachCardSm from 'components/coach-card-small'
import Container from '@material-ui/core/Container'
import StepDescriptionMobile from '../step-description-mobile'
import { useIsMobile } from 'lib/hooks'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import CoachLessonHeader from '../components/CoachLessonHeader'
import { ThemeProvider } from '@material-ui/core/styles'
import themes, { extendTheme } from 'themes'
import BackButton from '../components/BackButton'

export const GetStudents = ({
  currentUrl,
  previousUrl,
  isCoach,
  user,
  lessonTypeId,
}) => {
  const { data, loading, error } = useQuery(GetStudentsQuery)

  if (loading) return <SelectStudentSkeleton isCoach={isCoach} />
  if (error) return <Error error={error} />

  return (
    <>
      <SelectStudentLayout
        students={get(data, 'currentUser.students')}
        currentUrl={currentUrl}
        previousUrl={previousUrl}
        isCoach={isCoach}
        user={user}
        lessonTypeId={lessonTypeId}
      />
    </>
  )
}
export const GetStudentsRefresh = ({
  currentUrl,
  previousUrl,
  isCoach,
  user,
  lessonTypeId,
}) => {
  const { data, loading, error } = useQuery(GetStudentsQuery)

  if (loading) return <SelectStudentSkeleton isCoach={isCoach} />
  if (error) return <Error error={error} />

  return (
    <SelectStudentLayoutRefresh
      students={get(data, 'currentUser.students')}
      currentUrl={currentUrl}
      previousUrl={previousUrl}
      isCoach={isCoach}
      user={user}
      lessonTypeId={lessonTypeId}
    />
  )
}

export default ({
  currentUrl,
  previousUrl,
  lessonTypeId,
  lessonCreditBalanceQuantity,
}) => {
  const isMobile = useIsMobile()
  const [isOfferingsRefreshEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_COACH_OFFERING_REFRESH,
  ])
  const { isLoggedIn, isCoach, user } = useAuth()
  const { data, loading, error } = useQuery(LessonReviewQuery, {
    variables: {
      id: lessonTypeId,
    },
  })

  if (loading) return <SelectStudentSkeleton isCoach={isCoach} />
  if (error) return <Error error={error} />

  const lessonType = get(data, 'lessonTypes.0', {})
  const coach = lessonType?.coach
  const title = coach?.coachProfile?.title
  const profilePhoto = coach?.coachProfile?.profilePhoto

  return (
    <Container>
      {isOfferingsRefreshEnabled ? (
        <ThemeProvider theme={extendTheme(themes.offeringsRefresh)}>
          <Grid container>
            <BackButton previousUrl={previousUrl} />

            {coach && (
              <CoachLessonHeader lessonType={lessonType} coach={coach} />
            )}
            <Grid item xs={12}>
              {isLoggedIn ? (
                <>
                  <Grid item xs={12}>
                    <Divider style={{ margin: '1rem 0 2.25rem' }} />
                    <GetStudentsRefresh
                      {...{
                        currentUrl,
                        previousUrl,
                        isCoach,
                        user,
                        lessonTypeId,
                      }}
                    />
                  </Grid>
                </>
              ) : (
                <CreateAccountForBookingRefreshLayout
                  previousUrl={previousUrl}
                  theme={extendTheme(themes.offeringsRefresh)}
                />
              )}
            </Grid>
          </Grid>
        </ThemeProvider>
      ) : (
        <Grid container direction={isMobile ? 'row' : 'row-reverse'}>
          <Grid item md={3} xs={12}>
            <StepDescriptionMobile
              stepText="Step 2 of 3"
              previousUrl={previousUrl}
            />
            {coach && (
              <CoachCardSm
                coach={{
                  name: coach?.name,
                  coachAvatar: profilePhoto,
                  facilityName: title,
                }}
              />
            )}
            {lessonType && (
              <LessonTypeCard
                lessonInfo={lessonType}
                lessonCreditBalanceQuantity={lessonCreditBalanceQuantity}
              />
            )}
          </Grid>
          <Grid item md={9} xs={12}>
            {isLoggedIn ? (
              <GetStudents
                {...{ currentUrl, previousUrl, isCoach, user, lessonTypeId }}
              />
            ) : (
              <CreateAccountForBookingLayout previousUrl={previousUrl} />
            )}
          </Grid>
        </Grid>
      )}
    </Container>
  )
}
